// /qr — Ajaye's phone bookmark for showing the AdaptOS QR code in public.
// Full-screen white background — no dark theme, no nav, no footer.
// White is non-negotiable: dark QR codes on dark backgrounds fail to scan
// in bright outdoor light. All color tokens here are hard-coded literals
// (not CSS variables) so the user's theme preference can't override them.

export default function QrPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100vw',
        background: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px 16px',
        fontFamily: "'Hanken Grotesk', 'Inter', system-ui, sans-serif",
        boxSizing: 'border-box',
      }}
    >
      <img
        src="/qr-code.png"
        alt="QR code linking to adaptos.app"
        style={{
          width: '80vw',
          maxWidth: 500,
          height: 'auto',
          imageRendering: 'pixelated',
          display: 'block',
        }}
      />

      <p
        style={{
          marginTop: 24,
          fontSize: 18,
          fontWeight: 700,
          letterSpacing: '0.14em',
          color: '#1a1a21',
          textAlign: 'center',
          margin: '24px 0 0',
        }}
      >
        adaptos.app
      </p>

      <p
        style={{
          marginTop: 10,
          fontSize: 13,
          color: '#6a6a73',
          textAlign: 'center',
        }}
      >
        Scan to start 3 free IT certification lessons
      </p>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@300;400;500;600;700&display=swap');
        html, body { background: #ffffff; }
      `}</style>
    </div>
  );
}
